import React, { FunctionComponent, useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import BuyWidgetV2 from '@bitcoin-portal/bitcoincom-pkg-components/dist/BuyWidgetV2';

import { Wrapper } from './styled';

const Wallet: FunctionComponent = () => {
  const [cryptoType, setCryptoType] = useState<string>();
  const [loaded, setLoaded] = useState(false);
  /*
  // Other variables that may be necessary in the future if we switch providers
  const [lang, setLang] = useState<string>();
  const [externalTransactionId, setExternalTransactionId] = useState<string>();
  const [geo, setGeo] = useState(null);
  const [email, setEmail] = useState(null);
  */

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('crypto') && urlParams.get('crypto') !== 'null') {
      switch (urlParams.get('crypto')) {
        case 'avax_cchain':
          setCryptoType('AVAX-C');
          break;
        case 'matic_polygon':
          setCryptoType('MATIC');
          break;
        default: {
          const crypto = urlParams?.get('crypto')?.toUpperCase();
          setCryptoType(crypto || 'BTC');
        }
      }
    }

    /*
    // Other variables that may be necessary in the future if we switch providers
    if (urlParams.has('ref_id')) setExternalTransactionId(urlParams.get('ref_id') || undefined);
    if (urlParams.has('user_id')) setExternalTransactionId(urlParams.get('user_id') || undefined);
    if (urlParams.has('lang')) setLang(urlParams.get('lang') || undefined);
    if (urlParams.has('email')) setEmail(urlParams.get('email'));
    if (urlParams.has('geo')) setGeo(urlParams.get('geo'));
     */

    setLoaded(true);
  }, []);

  return (
    <main>
      <Wrapper>
        {loaded && (
          <BuyWidgetV2
            initialCrypto={cryptoType}
            selectedTab="sell"
            passThroughAddress
            callback={({ data, provider: cbProvider }) => {
              if (data.isSell) {
                navigate(`/${cbProvider}`, { state: data });
              } else {
                const params = new URLSearchParams({
                  ...(data.crypto && { crypto: data.crypto }),
                  ...(data.fiat && { fiat: data.fiat }),
                  ...(data.amount && { amount: data.amount }),
                  ...(data.address && { address: data.address }),
                });
                navigate(
                  `https://buy.bitcoin.com/${cbProvider}?${params.toString()}`,
                );
              }
            }}
            hideTabs
          />
        )}
      </Wrapper>
    </main>
  );
};

export default Wallet;
